import { createElement } from 'react';
import { redirect, RouteObject } from 'react-router-dom';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';
import { CountryService, DEFAULT_PAGE_SIZE, DEFAULT_SORT_ORDER } from 'entities/country';
import { pathKeys } from 'shared/lib/react-router';

import CountriesPage from './CountriesPage';

export const countriesPageRoute: RouteObject = {
  path: pathKeys.administration.countries(),
  element: createElement(CountriesPage),
  loader: async (args) => {
    const requiredPermissions = replacePermissions(pathPermissions.administration.countries, args.params);
    if (!isHasAccess(requiredPermissions)) {
      return redirect(pathKeys.dashboard());
    }

    Promise.resolve(
      CountryService.prefetchQuery({ size: DEFAULT_PAGE_SIZE, searchName: '', sort: DEFAULT_SORT_ORDER }),
    );
    return args;
  },
};
